<script setup>
/** 修改工作：发布人改标题、说明、验收标准；奖励已托管，不在这里改。 */
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { Button, Card, Input, Textarea } from '@drama/ui'

import { api, currentGuild, getToken, inGuild } from '../api.js'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const task = ref(null)
const form = ref(null)
const error = ref('')
const busy = ref(false)
const workPath = (suffix) => inGuild(`/api/voko/work${suffix}`)

onMounted(async () => {
  if (getToken() === null) {
    await router.push({ path: '/login', query: { next: route.fullPath } })
    return
  }
  if (currentGuild.slug === null) return
  task.value = (await api('GET', workPath(`/${route.params.id}`))).task
  form.value = { title: task.value.title, spec: task.value.spec, acceptance: task.value.acceptance.join('\n') }
})

async function save() {
  busy.value = true
  error.value = ''
  try {
    await api('POST', workPath(`/${task.value.id}/actions`), { action: 'edit', version: task.value.version, title: form.value.title, spec: form.value.spec,
      acceptance: form.value.acceptance.split('\n').map((line) => line.trim()).filter((line) => line !== '') })
    await router.push(`/work/${task.value.id}`)
  } catch (err) {
    error.value = err instanceof Error ? err.message : String(err)
  } finally {
    busy.value = false
  }
}
</script>

<template>
  <header class="page-head">
    <div>
      <p class="page-head__eyebrow">{{ t('okr.title') }}</p>
      <h1 class="page-head__title">{{ t('okr.edit') }}</h1>
    </div>
    <router-link :to="`/work/${route.params.id}`">{{ t('okr.dismiss') }}</router-link>
  </header>
  <Card v-if="form !== null">
    <form class="voko-form" @submit.prevent="save">
      <label>{{ t('okr.taskTitle') }}<Input v-model="form.title" :disabled="busy" required maxlength="200" /></label>
      <label>{{ t('okr.description') }}<Textarea v-model="form.spec" :disabled="busy" /></label>
      <label>{{ t('okr.acceptance') }}<Textarea v-model="form.acceptance" :disabled="busy" /></label>
      <p v-if="error" role="alert">{{ error }}</p>
      <Button type="submit" :disabled="busy || form.title.trim() === ''">{{ t('okr.save') }}</Button>
    </form>
  </Card>
</template>

<style scoped>
.voko-form { display: grid; gap: var(--drama-space-md); }
.voko-form label { display: grid; gap: var(--drama-space-sm); }
</style>
